import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Table,
  Header,
  Form,
  Loader,
} from 'semantic-ui-react';
import {
  DatesRangeInput
} from 'semantic-ui-calendar-react-17';
import PropTypes from 'prop-types';
import moment from 'moment';
import 'moment/locale/pt-br';
import _ from 'lodash';
import { PaginationContainer } from '../../components/PaginationContainer';
import { termActions } from '../../actions/term.actions';

const DATE_FORMAT = "DD/MM/YYYY";
const FILTER_FORMAT = "YYYY-MM-DD";

class TermAcceptancesScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      username: '',
      termId: null,
      period: '',
    };
  }

  static get propTypes() {
    return {
      acceptances: PropTypes.any,
      terms: PropTypes.any,
      loading: PropTypes.bool,
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    this.handleSearchDebounced = _.debounce(function () {
      this.fetchRegisters();
    }, 500);

    dispatch(termActions.fetch());

    const start = moment().startOf('month').format(DATE_FORMAT);
    const end = moment().endOf('month').format(DATE_FORMAT);
    this.setState({ period: `${start} - ${end}` }, () => this.fetchRegisters());
  }

  handlePageChange(activePage) {
    this.setState({ page: activePage }, () => this.fetchRegisters());
  }

  handlePeriodChange(period) {
    this.setState({ period, page: 1 }, () => this.fetchRegisters());
  }

  handleTermChange(termId) {
    this.setState({ termId, page: 1 }, () => this.fetchRegisters());
  }

  handleUsernameChange(username) {
    this.setState({ username, page: 1 });
    this.handleSearchDebounced();
  }

  fetchRegisters() {
    const { dispatch } = this.props;
    const { page, username, termId, period } = this.state;

    var [startDate, endDate] = period.split(' - ');
    if (startDate) {
      startDate = moment(startDate, DATE_FORMAT).format(FILTER_FORMAT);
    }
    if (endDate) {
      endDate = moment(endDate, DATE_FORMAT).format(FILTER_FORMAT);
    }

    dispatch(termActions.fetchAcceptances({
      page,
      username: username || null,
      termId: termId || null,
      startDate,
      endDate,
      orderBy: "AcceptedAt",
      ascending: false,
    }));
  }

  termOptions() {
    const { terms } = this.props;
    const options = [{ key: 'all', value: null, text: 'Todos os termos' }];
    if (terms) {
      terms.forEach((term) => {
        options.push({ key: term.Id, value: term.Id, text: `${term.Title} (v${term.Version})` });
      });
    }
    return options;
  }

  render() {
    const { acceptances, loading } = this.props;
    const { period, termId } = this.state;

    return (
      <Fragment>
        <Header>
          <h1>Aceite de Termos de Uso</h1>
        </Header>
        <Loader active={loading} />
        <Form>
          <Form.Group>
            <Form.Dropdown
              selection
              label='Termo'
              value={termId}
              options={this.termOptions()}
              onChange={(e, data) => this.handleTermChange(data.value)}
            />
            <DatesRangeInput
              name="period"
              localization="pt-br"
              placeholder="Período"
              value={period}
              iconPosition="left"
              dateFormat={DATE_FORMAT}
              label='Data do Aceite'
              closable={true}
              clearable={true}
              onChange={(e, data) => this.handlePeriodChange(data.value)}
            />
            <Form.Input icon='search' label='Usuário' onChange={(e, data) => this.handleUsernameChange(data.value)} loading={loading} />
          </Form.Group>
        </Form>

        {acceptances && acceptances.Results && acceptances.Results.length > 0 &&
          <Table compact>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Data do Aceite</Table.HeaderCell>
                <Table.HeaderCell>Usuário</Table.HeaderCell>
                <Table.HeaderCell>Versão</Table.HeaderCell>
                <Table.HeaderCell>Máquina</Table.HeaderCell>
                <Table.HeaderCell>IP</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              { acceptances.Results.map((register) => {
                return <Table.Row key={register.Id}>
                  <Table.Cell>{register.AcceptedAt ? moment(register.AcceptedAt).format('DD/MM/YYYY HH:mm:ss') : '-'}</Table.Cell>
                  <Table.Cell>{register.UserAccount}</Table.Cell>
                  <Table.Cell>{register.Version ?? '-'}</Table.Cell>
                  <Table.Cell>{register.ComputerName ?? '-'}</Table.Cell>
                  <Table.Cell>{register.IpAddress ?? '-'}</Table.Cell>
                </Table.Row>;
              }) }
            </Table.Body>
          </Table>}

        {acceptances && acceptances.Results && acceptances.Results.length == 0 &&
          <p>Nenhum aceite encontrado para os filtros selecionados.</p>}

        <PaginationContainer registers={acceptances} onPageChange={(e, { activePage }) => this.handlePageChange(activePage)} />
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { term } = state;

  return {
    acceptances: term?.acceptances || null,
    terms: term?.list || null,
    loading: term?.loading,
  };
}

const connectedTermAcceptancesScreen = connect(mapStateToProps)(TermAcceptancesScreen);
export { connectedTermAcceptancesScreen as TermAcceptancesScreen };
